<template>
  <div v-if="canAccessPage">
    <dashboard-inicial-filtro
      v-model="abrirFiltro"
      @DashboardInicialFiltro__AplicaFiltros="aplicarFiltros">
    </dashboard-inicial-filtro>

    <v-container fluid grid-list-md pa-0 ma-0>
      <v-row align="end" no-gutters class="filtros-principais">
        <v-col cols="10" class="d-flex">
          <div class="filtros filtros-principais__campos">
            <v-autocomplete
              id="autocomplete-ano-fiscal"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-model="anoFiscal"
              return-object
              :items="anosFiscais"
              :label="$tc('label.ano_planejamento', 1)"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="descricao"
              item-value="id"
              :placeholder="$tc('label.ano_planejamento', 1)"
              clearable
              @input="anoFiscalAlterado">
              <template v-slot:selection="{item, index}">
                <v-chip
                  close
                  @click:close="anoFiscalAlterado(anoFiscal = null)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{ (item && item.descricao) ? String(item.descricao).substring(0, 15) : (item && item.text ? String(item.text).substring(0, 15) : '') }}
                      </span>
                    </template>
                    <p class="ma-2 mb-3">{{ (item && item.descricao) ? String(item.descricao) : (item && item.text ? String(item.text) : '') }}</p>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-mes"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-model="mesSelecionado"
              return-object
              :items="meses"
              :label="$tc('label.mes_planejamento', 1)"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nome"
              item-value="numero"
              :placeholder="$tc('label.mes_planejamento', 1)"
              clearable
              @input="mesAlterado">
              <template v-slot:selection="{item}">
                <v-chip
                  close
                  @click:close="mesAlterado(mesSelecionado = null)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{ item.nome ? item.nome.substring(0, 15) : '' }}
                      </span>
                    </template>
                    <p class="ma-2 mb-3">{{ item.nome }}</p>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-regional"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-model="regional"
              return-object
              :items="regionaisItens"
              label="Regional"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nome"
              item-value="id"
              :clearable="true"
              @focus="buscarRegionaisUsuario"
              @click.native="buscarRegionaisUsuario"
              @input="regionalAlterada"
              multiple
              chips
              deletable-chips>
              <template v-slot:selection="{item, index}">
                <v-chip v-if="index < 3"
                  :input-value="item"
                  close
                  @click:close="regional.splice(index, 1); regionalAlterada()">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{ item.nome ? item.nome.substring(0, 15): '' }}
                      </span>
                    </template>
                    <v-row>
                      <p class="ma-2 mb-3">{{ item.nome }}</p>
                    </v-row>
                  </v-tooltip>
                </v-chip>
                <v-chip v-if="index > 2 && index + 1 === regional.length">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{`+${regional.length - 3}`}}
                      </span>
                    </template>
                    <div v-for="(linha, i) in regional" v-bind:key="linha.id">
                      <v-row v-if="i > 2">
                        <p class="ma-2 mb-3">{{ linha.nome }}</p>
                      </v-row>
                    </div>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-divisao"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-if="true"
              v-model="divisao"
              return-object
              :items="divisoesItens"
              :label="`${this.$tc('label.divisao', 1)}`"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nome"
              item-value="id"
              :clearable="true"
              @focus="buscarDivisoesUsuario"
              @click.native="buscarDivisoesUsuario"
              @input="divisaoAlterada"
              multiple
              chips
              deletable-chips
              >
              <template
                  v-slot:selection="{item, index}">
                  <v-chip v-if="index < 3"
                    :input-value="item"
                    close
                    @click:close="divisao.splice(index, 1); divisaoAlterada()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                           {{ item.nome ? item.nome.substring(0, 15): '' }}
                        </span>
                      </template>
                      <v-row>
                        <p class="ma-2 mb-3">{{ item.nome }}</p>
                      </v-row>
                    </v-tooltip>
                  </v-chip>

                  <v-chip v-if="index > 2 && index + 1 === divisao.length">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                          {{`+${divisao.length - 3}`}}
                        </span>
                      </template>
                      <div v-for="(linha, i) in divisao" v-bind:key="linha.id">
                        <v-row v-if="i > 2">
                          <p class="ma-2 mb-3">{{ linha.nome }}</p>
                        </v-row>
                      </div>
                    </v-tooltip>
                  </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-grupo-economico"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-if="true"
              v-model="grupo"
              return-object
              :items="gruposItens"
              :label="`${this.$tc('label.grupoeconomico', 1)}`"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nomExtensao"
              item-value="id"
              :clearable="true"
              @focus="buscaGrupos"
              @input="grupoAlterado"
              >
              <template
                  v-slot:selection="{item}">
                  <v-chip
                    :input-value="item"
                    close
                    @click:close="grupoAlterado(grupo = null)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                           {{ item.nomExtensao ? item.nomExtensao.substring(0, 15): '' }}
                        </span>
                      </template>
                      <v-row>
                        <p class="ma-2 mb-3">{{ item.nomExtensao }}</p>
                      </v-row>
                    </v-tooltip>
                  </v-chip>
              </template>
            </v-autocomplete>
          </div>
        </v-col>
        <v-col cols="2" class="d-flex align-end justify-end py-0">
          <v-badge
            color="red"
            :content="pendenciasCount"
            :value="pendenciasCount > 0"
            overlap
            offset-x="12"
            offset-y="12">
            <v-btn
              rounded
              color="primary"
              dark
              @click="mostrarPendencias = !mostrarPendencias">
              <v-icon left small>notifications</v-icon>
              {{ $tc('label.aprovacoes', 1) }}
            </v-btn>
          </v-badge>
          <v-icon class="ml-2" v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
      <v-row>
        <div style="overflow-y: auto; overflow-x: hidden;">
          <metadados-container-filtro-layout
            v-show="true"
            :metadados-entidade="metadadosCopia"
            :ordenacao-campos="ordenacaoCampos"
            :campos-formulario="camposFormulario"
            :grupo-expandido="grupoExpandido"
            :explode-hierarquia="true"
            :formulario-filtros="formularioFiltros"
            :ignora-obrigatorios="ignoraObrigatorios"
            :layout-class="layoutClass"
            :input-layout="inputLayout"
            :objeto="filtros"
            ref="container"
            @MetadadosContainerFiltroLayout__gruposCarregados="conteinerCarregado">
          </metadados-container-filtro-layout>
        </div>
      </v-row>
      <v-row>
        <v-col cols="12" :sm="mostrarPendencias ? 6 : 12" :md="mostrarPendencias ? 8 : 12" class="pt-0">
          <div class="filtros" style="display: flex;">
            <v-autocomplete
              id="autocomplete-tipo-verba"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="$tc('label.tipo_de_verba', 1)"
              v-model="tipoVerba"
              :items="tiposVerba"
              :clearable="true"
              item-text="nome"
              item-value="id"
              @input="tipoVerbaAlterado"
              chips
              deletable-chips
              multiple>
              <template v-slot:selection="{item, index}">
                <v-chip v-if="index < 3"
                  :input-value="item"
                  close
                  @click:close="tipoVerba.splice(index, 1); tipoVerbaAlterado()">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{ item.nome ? item.nome.substring(0, 15) : '' }}
                      </span>
                    </template>
                    <v-row>
                      <p class="ma-2 mb-3">{{ item.nome }}</p>
                    </v-row>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="tipo-acao"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.tipo_acao', 1)}`"
              v-model="tipoAcao"
              :items="tiposAcao"
              :clearable="true"
              item-text="nome"
              item-value="id"
              @input="tipoAcaoAlterada"
              chips
              deletable-chips
              multiple>
              <template
                  v-slot:selection="{item, index}">
                  <v-chip v-if="index < 3"
                    :input-value="item"
                    close
                    @click:close="tipoAcao.splice(index, 1); tipoAcaoAlterada()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                           {{ item.nome ? item.nome.substring(0, 15): '' }}
                        </span>
                      </template>
                      <v-row>
                        <p class="ma-2 mb-3">{{ item.nome }}</p>
                      </v-row>
                    </v-tooltip>
                  </v-chip>

                  <v-chip v-if="index > 2 && index + 1 === tipoAcao.length">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                          {{`+${tipoAcao.length - 3}`}}
                        </span>
                      </template>
                      <div v-for="(id, i) in tipoAcao" v-bind:key="id">
                        <v-row v-if="i > 2">
                          <p class="ma-2 mb-3">
                            {{ (tiposAcao && tiposAcao.length ? (tiposAcao.find((t) => t.id === id) || {}).nome : '') }}
                          </p>
                        </v-row>
                      </div>
                    </v-tooltip>
                  </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-orcamento"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-if="true"
              v-model="orcamento"
              :items="orcamentos"
              return-object
              :label="`${this.$tc('label.descricao_orcamento', 1)}`"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="descricao"
              item-value="id"
              :placeholder="$tc('label.descricao_orcamento', 1)"
              :clearable="true"
              @click.native="() => buscaOrcamentos()"
              @input="orcamentoAlterado"
              chips
              deletable-chips
              multiple
              >
              <template
                  v-slot:selection="{item, index}">
                  <v-chip v-if="index < 3"
                    :input-value="item"
                    close
                    @click:close="orcamento.splice(index, 1); orcamentoAlterado()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                           {{ item.descricao ? item.descricao.substring(0, 15): '' }}
                        </span>
                      </template>
                      <v-row>
                        <p class="ma-2 mb-3">{{ item.descricao }}</p>
                      </v-row>
                    </v-tooltip>
                  </v-chip>

                  <v-chip v-if="index > 2 && index + 1 === orcamento.length">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                          {{`+${orcamento.length - 3}`}}
                        </span>
                      </template>
                      <div v-for="(linha, i) in orcamento" v-bind:key="linha.id">
                        <v-row v-if="i > 2">
                          <p class="ma-2 mb-3">{{ linha.descricao }}</p>
                        </v-row>
                      </div>
                    </v-tooltip>
                  </v-chip>
              </template>
            </v-autocomplete>

            <v-autocomplete
              id="autocomplete-periodo"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-if="true"
              v-model="periodo"
              :items="periodos"
              return-object
              :label="`${this.$tc('label.periodo_do_orcamento', 1)}`"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="descricao"
              item-value="id"
              :placeholder="$tc('label.periodo_do_orcamento', 1)"
              :clearable="true"
              @click.native="() => buscaPeriodos()"
              @input="periodoAlterado"
              multiple
              >
              <template
                  v-slot:selection="{item, index}">
                  <v-chip v-if="index < 3"
                    :input-value="item"
                    close
                    @click:close="periodo.splice(index, 1); periodoAlterado()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                           {{ item.descricao ? item.descricao.substring(0, 15): '' }}
                        </span>
                      </template>
                      <v-row>
                        <p class="ma-2 mb-3">{{ item.descricao }}</p>
                      </v-row>
                    </v-tooltip>
                  </v-chip>

                  <v-chip v-if="index > 2 && index + 1 === periodo.length">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span class="trunc-ellipsis" v-on="on">
                          {{`+${periodo.length - 3}`}}
                        </span>
                      </template>
                      <div v-for="(linha, i) in periodo" v-bind:key="linha.id">
                        <v-row v-if="i > 2">
                          <p class="ma-2 mb-3">{{ linha.descricao }}</p>
                        </v-row>
                      </div>
                    </v-tooltip>
                  </v-chip>
              </template>
            </v-autocomplete>
            <v-autocomplete
              id="autocomplete-status-pagamento"
              class="custom-autocomplete"
              style="padding: 0px 12px"
              v-model="statusPagamento"
              :items="statusesPagamento"
              :label="`${$tc('label.status_pagamento', 1)}`"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              item-text="nome"
              item-value="id"
              :clearable="true"
              @input="statusPagamentoAlterado">
              <template v-slot:selection="{item}">
                <v-chip
                  close
                  @click:close="statusPagamentoAlterado(statusPagamento = null)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span class="trunc-ellipsis" v-on="on">
                        {{ item.nome ? item.nome.substring(0, 15) : '' }}
                      </span>
                    </template>
                    <p class="ma-2 mb-3">{{ item.nome }}</p>
                  </v-tooltip>
                </v-chip>
              </template>
            </v-autocomplete>
          </div>
          <v-row align="center" justify="end" style="margin-bottom: 10px">
            <v-btn slot="acoes-padrao" @click="limparFiltros()"
              class="mr-3"
              dark
              color="accent"
              v-show="true">
              {{ $t('label.limpar') }}
            </v-btn>
          </v-row>
          <v-row v-if="!isLoading">
            <kpi-cards :filtros="subFiltros" @cards="dadosCards = $event" />
          </v-row>
          <v-row v-if="!isLoading" class="mt-2 mb-0">
            <v-col cols="12" class="text-center pb-0">
              <p class="grafico-title mb-0">
                {{ $t('label.composicao_valor_planejado') }}
              </p>
            </v-col>
          </v-row>
          <container-graficos
            :filtros="subFiltros"
            v-if="!isLoading"
          />
          <v-row>
            <v-col cols="12" md="12" class="px-3">
              <paineis-dash-funcionario
                ref="paineisDashFuncionario"
                :filtros="subFiltros"
                :dados-cards="dadosCards"
                @abreModalLista="openModal"
              >
              </paineis-dash-funcionario>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pt-0" v-show="mostrarPendencias">
          <v-row>
              <v-col cols="12" d-flex >
                <dashboard-pendencias-planejamento
                  :filtros="filtros"
                  @update:total-pendencias="(v) => atualizarContadorPendencias('planejamento', v)" />
              </v-col>
              <v-col cols="12" d-flex >
                <dashboard-pendencias-apuracao
                  :filtros="filtros"
                  @update:total-pendencias="(v) => atualizarContadorPendencias('apuracao', v)" />
              </v-col>
              <v-col cols="12" d-flex >
                <dashboard-pendencias-orcamento
                  :filtros="filtros"
                  @update:total-pendencias="(v) => atualizarContadorPendencias('orcamento', v)" />
              </v-col>
              <v-col cols="12" d-flex >
                <dashboard-pendencias-ajuste-verba
                  :filtros="filtros"
                  @update:total-pendencias="(v) => atualizarContadorPendencias('ajusteVerba', v)" />
              </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <painel-lista-modal
      ref="painelListaModal"
      v-if="modalOn"
      :dados="dadosModal"
      @close="closeModal">
    </painel-lista-modal>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import 'moment/locale/pt-br';
import { mapGetters } from 'vuex';
import DashboardPendenciasAjusteVerba from '@/spa/dashboard-inicial/DashboardPendenciasAjusteVerba';
import MetadadosContainerFiltroLayout from '../../../../produto/shared-components/metadados/MetadadosContainerFiltroLayout';
import DashboardFuncionarioIndustriaRankingPagamento from '../../../../produto/spa/dashboard-inicial/industria/dashboard-funcionario/DashFuncionarioIndustriaRankingPagamento';

import DashboardPendenciasApuracao from '../../../../produto/spa/dashboard-inicial/DashboardPendenciasApuracao';
import DashboardPendenciasPlanejamento from '../../../../produto/spa/dashboard-inicial/DashboardPendenciasPlanejamento';
import DashboardPendenciasOrcamento from '../../../../produto/spa/dashboard-inicial/DashboardPendenciasOrcamento';
import DashboardInicialFiltro from '../../../../produto/spa/dashboard-inicial/DashboardInicialFiltro';
import PaineisDashFuncionario from './PaineisDashFuncionario';
import PainelListaModal from './PainelListaModal';
import ContainerGraficos from './charts/ContainerGraficos';
import KpiCards from './KpiCards';

import DashboardIndustriaGrafico from '../../../../produto/spa/dashboard-inicial/industria/DashIndustriaGrafico';
import { buscarPeriodo, buscarOrcamento } from '../../../../common/resources/conta-corrente-extrato/extrato-conta-corrente';
import { buscarHoldings } from '../../../../produto/common/resources/planejamento/planejamento-acao-cadastro';
import { buscarRegionaisGerente, buscarDivisoesUsuario as apiBuscarDivisoesUsuario } from '../../../../common/resources/akzo-chart';

export default {
  name: 'DashboardInicial',
  data() {
    return {
      dadosModal: null,
      modalOn: false,
      filtros: {},
      dadosCards: {},
      subFiltros: {
        ano_fiscal: null,
      },
      ExtratoGrupoEconomico: this.$api.akzoExtratoContaCorrente(this.$resource),
      configuracaoResource: this.$api.planejamentoAcaoConfiguracao(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      tipoAcaoResource: this.$api.tipoAcao(this.$resource),
      anoFiscalResource: this.$api.akzoAnoFiscal(this.$resource),
      abrirFiltro: false,
      mostrarPendencias: false,
      mesSelecionado: {
        numero: null,
        nome: this.$tc('label.todos', 1),
      },
      anoFiscal: null,
      anosFiscais: [],
      idTipoVerba: null,
      idPeriodo: null,
      tipoVerba: [],
      tiposVerba: [],
      periodo: null,
      periodos: [],
      orcamento: null,
      idOrcamento: null,
      orcamentos: [],
      opcaoTodos: {
        id: 'TODOS',
        nome: this.$tc('label.todos', 1),
      },
      opcaoTodosGrupo: {
        id: 'TODOS',
        nomExtensao: this.$tc('label.todos', 1),
      },
      grupo: null,
      divisao: [],
      regional: [],
      idRegional: null,
      carregandoDivisoes: false,
      carregandoRegionais: false,
      descricaoGrupo: null,
      grupos: [],
      divisoes: [],
      regionais: [],
      metadadosCopia: {},
      ordenacaoCampos: [],
      camposFormulario: {},
      formularioFiltros: true,
      ignoraObrigatorios: true,
      layoutClass: {},
      inputLayout: {},
      conteinerCarregado: [],
      grupoExpandido: '',
      tipoAcao: [],
      tiposAcao: [],
      statusPagamento: null,
      isLoading: true,
      pendenciasPorTipo: {
        planejamento: 0,
        apuracao: 0,
        orcamento: 0,
        ajusteVerba: 0,
      },
    };
  },
  components: {
    PainelListaModal,
    PaineisDashFuncionario,
    KpiCards,
    ContainerGraficos,
    DashboardIndustriaGrafico,
    DashboardInicialFiltro,
    DashboardPendenciasPlanejamento,
    DashboardPendenciasOrcamento,
    DashboardPendenciasApuracao,
    DashboardFuncionarioIndustriaRankingPagamento,
    DashboardPendenciasAjusteVerba,
    MetadadosContainerFiltroLayout,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'DASH_INDUSTRIA').length;
    },
    pendenciasCount() {
      return Object.values(this.pendenciasPorTipo).reduce((soma, v) => soma + (v || 0), 0);
    },
    regionaisItens() {
      return [this.opcaoTodos, ...this.regionais];
    },
    divisoesItens() {
      return [this.opcaoTodos, ...this.divisoes];
    },
    gruposItens() {
      return [this.opcaoTodosGrupo, ...this.grupos];
    },
    meses() {
      moment.locale('pt-br');
      const mesesList = Array.from({ length: 12 }, (_, i) => {
        const mesAbreviado = moment().month(i).format('MMM');
        return {
          numero: i + 1,
          nome: mesAbreviado.charAt(0).toUpperCase() + mesAbreviado.slice(1),
        };
      });
      return [
        {
          numero: null,
          nome: this.$tc('label.todos', 1),
        },
        ...mesesList,
      ];
    },
    statusesPagamento() {
      return [
        { id: 'LIQUIDADO', nome: this.$tc('label.liquidado', 1) },
        { id: 'NAO_LIQUIDADO', nome: this.$tc('label.nao_liquidado', 1) },
      ];
    },
  },
  watch: {
    tipoVerba: {
      handler() {
        this.orcamentos = [];
        this.periodo = [];
        this.idPeriodo = null;
        this.idOrcamento = null;
      },
    },
    orcamento: {
      handler() {
        this.periodo = [];
        this.idPeriodo = null;
      },
    },
    anoFiscal: {
      handler(newVal, oldVal) {
        if (newVal === null && oldVal !== null && this.anosFiscais.length > 0) {
          this.$nextTick(() => {
            this.anoFiscal = this.anoFiscalPadrao();
            this.subFiltros.ano_fiscal = this.anoFiscal.id;
          });
        }
      },
    },
  },
  methods: {
    atualizarContadorPendencias(tipo, total) {
      this.$set(this.pendenciasPorTipo, tipo, total || 0);
    },
    openModal(dados) {
      this.modalOn = true;
      this.dadosModal = dados;
    },
    closeModal() {
      this.modalOn = false;
    },
    aplicarSubFiltros() {
      let idsTipoAcaoSelecionados = [];
      if (Array.isArray(this.tipoAcao)) {
        idsTipoAcaoSelecionados = this.tipoAcao;
      } else if (this.tipoAcao) {
        idsTipoAcaoSelecionados = [this.tipoAcao];
      }
      this.subFiltros = {
        ...this.subFiltros,
        mes: this.mesSelecionado ? this.mesSelecionado.numero : null,
        ano_fiscal: this.anoFiscal ? this.anoFiscal.id : null,
        id_tipo_verba: this.idTipoVerba ? this.idTipoVerba : null,
        id_periodo: this.idPeriodo ? this.idPeriodo : null,
        id_periodo_orcamentario: this.idPeriodo ? this.idPeriodo : null,
        id_orcamento: this.idOrcamento ? this.idOrcamento : null,
        id_grupo: this.idGrupo ? this.idGrupo : null,
        id_holding: this.idGrupo ? this.idGrupo : null,
        id_divisao: this.idDivisao ? this.idDivisao : null,
        id_regiao: this.idRegional ? this.idRegional : null,
        id_acao_selecionada: idsTipoAcaoSelecionados.length === 1 ? idsTipoAcaoSelecionados[0] : null,
        id_acao_tipo: idsTipoAcaoSelecionados.length > 0 ? idsTipoAcaoSelecionados : null,
        status_pagamento: this.statusPagamento || null,
      };

      this.$nextTick(() => {
        this.$refs.paineisDashFuncionario.buscarAcoes();
        this.$refs.paineisDashFuncionario.buscarContratos();
        this.$refs.paineisDashFuncionario.buscarResumo();
      });
    },
    limparFiltros() {
      this.mesSelecionado = {
        numero: null,
        nome: this.$tc('label.todos', 1),
      };
      this.subFiltros.mes = null;
      if (this.anosFiscais.length > 0) {
        this.anoFiscal = this.anoFiscalPadrao();
        this.subFiltros.ano_fiscal = this.anoFiscal.id;
      } else {
        this.anoFiscal = null;
        this.subFiltros.ano_fiscal = null;
      }
      this.tipoAcao = [];
      this.subFiltros.id_acao_tipo = null;
      this.subFiltros.id_acao_selecionada = null;
      this.idTipoVerba = null;
      this.idPeriodo = null;
      this.subFiltros.id_tipo_verba = null;
      this.subFiltros.id_periodo = null;
      this.subFiltros.id_periodo_orcamentario = null;
      this.subFiltros.id_orcamento = null;
      this.subFiltros.id_grupo = null;
      this.subFiltros.id_holding = null;
      this.descricaoGrupo = null;
      this.idOrcamento = null;
      this.tipoVerba = [];
      this.periodo = null;
      this.periodos = [];
      this.tipoAcao = [];
      this.orcamento = null;
      this.idOrcamento = null;
      this.orcamentos = [];
      this.restaurarTodos('grupo');
      this.restaurarTodos('divisao');
      this.restaurarTodos('regional');
      this.idGrupo = null;
      this.idDivisao = null;
      this.idRegional = null;
      this.subFiltros.id_divisao = null;
      this.subFiltros.id_regiao = null;
      this.statusPagamento = null;
      this.subFiltros.status_pagamento = null;
      this.grupos = [];
      this.$refs.paineisDashFuncionario.buscarAcoes();
      this.$refs.paineisDashFuncionario.buscarContratos();
      this.$refs.paineisDashFuncionario.buscarResumo();
    },
    mesAlterado() {
      this.aplicarSubFiltros();
    },
    anoFiscalAlterado() {
      this.aplicarSubFiltros();
    },
    tipoVerbaAlterado() {
      const selecionados = Array.isArray(this.tipoVerba) ? this.tipoVerba : [];
      if (selecionados.length === 1) {
        const [idSelecionado] = selecionados;
        this.idTipoVerba = idSelecionado;
      } else if (selecionados.length > 1) {
        this.idTipoVerba = selecionados;
      } else {
        this.idTipoVerba = null;
        this.subFiltros.id_tipo_verba = null;
      }
      this.aplicarSubFiltros();
    },
    periodoAlterado() {
      if (this.periodo && this.periodo.length > 0) {
        this.idPeriodo = this.periodo.map((item) => item.id);
      } else {
        this.idPeriodo = null;
        this.subFiltros.id_periodo = null;
      }
      this.aplicarSubFiltros();
    },
    tipoAcaoAlterada() {
      this.aplicarSubFiltros();
    },
    statusPagamentoAlterado() {
      this.aplicarSubFiltros();
    },
    ehTodos(item) {
      return !item || item.id == null || item.id === 'TODOS';
    },
    itensReais(lista) {
      return (lista || []).filter((item) => !this.ehTodos(item));
    },
    idsIguais(atual, proximo) {
      const atualNorm = atual || [];
      const proximoNorm = proximo || [];
      return atualNorm.length === proximoNorm.length
        && atualNorm.every((id, index) => id === proximoNorm[index]);
    },
    restaurarTodos(campo) {
      if (campo === 'grupo') {
        if (this.grupo !== this.opcaoTodosGrupo) {
          this.grupo = this.opcaoTodosGrupo;
        }
        return;
      }
      if (!this.estaSomenteTodos(this[campo])) {
        this[campo] = [this.opcaoTodos];
      }
    },
    estaSomenteTodos(lista) {
      return Array.isArray(lista) && lista.length === 1 && this.ehTodos(lista[0]);
    },
    grupoAlterado(grupo) {
      if (!this.ehTodos(grupo)) {
        this.idGrupo = grupo.id;
        this.aplicarSubFiltros();
        return;
      }
      this.restaurarTodos('grupo');
      if (this.idGrupo != null) {
        this.idGrupo = null;
        this.subFiltros.id_grupo = null;
        this.subFiltros.id_holding = null;
        this.aplicarSubFiltros();
      }
    },
    regionalAlterada() {
      const reais = this.itensReais(this.regional);
      if (reais.length) {
        if (reais.length !== this.regional.length) {
          this.regional = reais;
        }
        const ids = reais.map((item) => item.id);
        if (!this.idsIguais(this.idRegional, ids)) {
          this.idRegional = ids;
          this.aplicarSubFiltros();
        }
        return;
      }
      this.restaurarTodos('regional');
      if (this.idRegional) {
        this.idRegional = null;
        this.subFiltros.id_regiao = null;
        this.aplicarSubFiltros();
      }
    },
    divisaoAlterada() {
      const reais = this.itensReais(this.divisao);
      if (reais.length) {
        if (reais.length !== this.divisao.length) {
          this.divisao = reais;
        }
        const ids = reais.map((item) => item.id);
        if (!this.idsIguais(this.idDivisao, ids)) {
          this.idDivisao = ids;
          this.aplicarSubFiltros();
        }
        return;
      }
      this.restaurarTodos('divisao');
      if (this.idDivisao) {
        this.idDivisao = null;
        this.subFiltros.id_divisao = null;
        this.aplicarSubFiltros();
      }
    },
    orcamentoAlterado() {
      if (this.orcamento && this.orcamento.length > 0) {
        this.idOrcamento = this.orcamento.map((item) => item.id);
      } else {
        this.idOrcamento = null;
        this.subFiltros.id_orcamento = null;
      }
      this.aplicarSubFiltros();
    },
    buscaTiposVerba() {
      const params = {};

      if (this.idDivisao && this.idDivisao.length > 0) {
        params.idDivisao = this.idDivisao;
      }
      if (this.idGrupo) {
        params.idGrupo = this.idGrupo;
      }

      this.ExtratoGrupoEconomico.tiposVerba(params)
        .then((res) => {
          this.tiposVerba = (res.data || []).filter((item) => item && item.id != null
            && item.nome !== this.$tc('label.todos', 1));
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaPeriodos() {
      let param = {};
      param = {};
      if (this.idTipoVerba || this.idOrcamento) {
        if (!this.idOrcamento || this.orcamento === null) {
          this.idOrcamento = null;
          param = {
            idTipoVerba: this.idTipoVerba,
            idsContaCorrente: this.grupoEconomico,
          };
        } else {
          param = {
            idTipoVerba: this.idTipoVerba,
            idsContaCorrente: this.grupoEconomico,
            idOrcamento: this.idOrcamento,
          };
        }
        buscarPeriodo(param, this.$resource)
          .then((res) => {
            this.periodos = res.data;
          })
          .catch((err) => {
            this.$toast(err.data.error);
          });
      } else {
        buscarPeriodo(param, this.$resource)
          .then((res) => {
            this.periodos = res.data;
          })
          .catch((err) => {
            this.$toast(err.data.error);
          });
      }
    },
    buscarTipoAcao() {
      this.tipoAcaoResource
        .buscarAtivos()
        .then((res) => {
          this.tiposAcao = res.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscaOrcamentos() {
      const param = {
        idTipoVerba: this.idTipoVerba,
        id_holding: this.idGrupo,
      };

      if (this.idDivisao && this.idDivisao.length > 0) {
        param.idDivisao = this.idDivisao;
      }
      if (this.idGrupo) {
        param.idGrupo = this.idGrupo;
      }

      buscarOrcamento(param, this.$resource)
        .then((res) => {
          this.orcamentos = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaGrupos() {
      if (this.grupos.length) {
        return;
      }
      buscarHoldings({}, this.$resource)
        .then((res) => {
          this.grupos = res.body || [];
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarDivisoesUsuario() {
      if (this.divisoes.length || this.carregandoDivisoes) {
        return;
      }
      this.carregandoDivisoes = true;
      apiBuscarDivisoesUsuario({}, this.$resource)
        .then((res) => {
          const dados = res.data || res.body || [];
          this.divisoes = dados.length > 1 ? dados.slice().sort(this.compare) : dados;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        })
        .finally(() => {
          this.carregandoDivisoes = false;
        });
    },
    buscarRegionaisUsuario() {
      if (this.regionais.length || this.carregandoRegionais) {
        return;
      }
      this.carregandoRegionais = true;
      buscarRegionaisGerente({}, this.$resource)
        .then((res) => {
          const dados = res.data || res.body || [];
          this.regionais = dados.length > 1 ? dados.slice().sort(this.compare) : dados;
        })
        .catch((err) => {
          this.$error(this, err);
        })
        .finally(() => {
          this.carregandoRegionais = false;
        });
    },
    compare(item1, item2) {
      if (item1.nome < item2.nome) {
        return -1;
      }
      if (item1.nome > item2.nome) {
        return 1;
      }
      return 0;
    },
    aplicarFiltros(filtrosAplicados) {
      if (!filtrosAplicados || !this.filtroPeriodoValido(filtrosAplicados)) {
        return;
      }
      if (!filtrosAplicados.data_inicio && !filtrosAplicados.data_fim) {
        filtrosAplicados.data_inicio = moment(new Date(new Date().getFullYear(), 0, 1), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
        filtrosAplicados.data_fim = moment(new Date(new Date().getFullYear(), 11, 31), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
      }
      this.filtros = {
        ...filtrosAplicados,
      };
    },
    filtroPeriodoValido(filtrosAplicados) {
      if (filtrosAplicados.data_inicio || filtrosAplicados.data_fim) {
        let dtInicio = '';
        let dtFinal = '';
        dtInicio = this.moment(filtrosAplicados.data_inicio, 'YYYY-MM-DD');
        dtFinal = this.moment(filtrosAplicados.data_fim, 'YYYY-MM-DD');

        if (dtFinal.isBefore(dtInicio)) {
          this.$toast(this.$t('message.data_final_antes_inicial'));
          return false;
        }
        if ((filtrosAplicados.data_inicio && !filtrosAplicados.data_fim)
          || (!filtrosAplicados.data_inicio && filtrosAplicados.data_fim)) {
          this.$toast(this.$t('message.data_final_e_inicial'));
          return false;
        }
        return true;
      }
      return true;
    },
    anoFiscalPadrao() {
      const anoAtual = new Date().getFullYear();
      return this.anosFiscais.find((a) => a.id === anoAtual) || this.anosFiscais[0];
    },
    buscarAnosFiscais() {
      this.anoFiscalResource.listarAnosFiscais()
        .then((res) => {
          this.anosFiscais = res.data.map((item) => ({
            id: item,
            descricao: String(item),
          }));
          if (!this.anoFiscal && this.anosFiscais.length > 0) {
            this.anoFiscal = this.anoFiscalPadrao();
            this.subFiltros.ano_fiscal = this.anoFiscal.id;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  created() {
    this.grupo = this.opcaoTodosGrupo;
    this.divisao = [this.opcaoTodos];
    this.regional = [this.opcaoTodos];
  },
  mounted() {
    this.buscarAnosFiscais();
    this.buscaTiposVerba();
    this.buscarTipoAcao();
  },
};
</script>
<style scoped>
.filtros-principais {
  padding-top: 15px;
  padding-bottom: 8px;
}

.filtros-principais__campos {
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 8px;
}

.filtros-principais__campos >>> .v-autocomplete {
  flex: 1;
  min-width: 0;
  padding: 0 4px !important;
}

.filtros-principais >>> .v-label {
  font-size: 18px !important;
  line-height: 1.2;
}

.filtros-principais >>> .v-label--active {
  transform: translateY(-28px) scale(0.85) !important;
}

.filtros-principais >>> .v-text-field {
  padding-top: 12px;
  margin-top: 10px;
}

.filtros-principais >>> .v-text-field__details {
  display: none;
}
</style>
